<template>
    <div class="services-details-area ptb-100 d-flex align-items-center justify-content-center" style="min-height: 100vh;">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-12">
                    <div class="services-details-image text-center mb-4">
                        <img src="../../assets/images/services/orofacial-pain/orofacial_main_page.webp" alt="image">
                    </div>

                    <div class="services-details-content">
                        <u><h3>{{ $t('orofacial_title') }}</h3></u>
                        <p>{{ $t('orofacial_p') }}</p> 
                    </div>

                    <div class="services-details-content">
                        <u><h3>{{ $t('orofacial_title_what') }}</h3></u>
                        <p>{{ $t('orofacial_title_what_p') }}</p> 
                    </div>

                    <div class="services-details-content">
                        <u><h3>{{ $t('orofacial_title_symptoms') }}</h3></u>
                        <p>{{ $t('orofacial_title_symptoms_p') }}</p> 
                    </div>

                    <div class="services-details-content">
                        <u><h3>{{ $t('orofacial_title_therapy') }}</h3></u>
                        <p>{{ $t('orofacial_title_therapy_p') }}</p> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>


    export default {
        name: 'OrofacialPain',
    };
    
</script>
